import React from 'react';
import { FaHeart, FaRegHeart, FaShareAlt } from 'react-icons/fa';

// import required modules

import { useAuth } from '../../../../../../components/context/Info';
import { NumeroFormatado } from '../../../../../../utils/FunctionsGlobals';
import { unidadeDoTerreno } from '../../../../../../utils/unidadeArea';
import styles from './Botoes.module.css';

const Compartilhar: React.FC<{
    detailsProperties: any;
    favorito?: any;
}> = ({
    detailsProperties,
    favorito
}) => {
    const {
        delete_favorito,
        include_favorito
    } = useAuth();

    const handleShare = async () => {
        const text = `${detailsProperties?.tipo?.nome} ${
            detailsProperties?.area_privativa > 0
                ? " com " + NumeroFormatado(Number(detailsProperties?.area_privativa)) + " m² privativos, "
                : detailsProperties?.area_total > 0
                ? " com " + NumeroFormatado(Number(detailsProperties?.area_total)) + " m² de área total, "
                : detailsProperties?.terreno > 0
                ? " com " + NumeroFormatado(Number(detailsProperties?.terreno)) + " " + unidadeDoTerreno(detailsProperties?.area_tipo) + " de área terreno, "
                : ""
            }${
                detailsProperties?.dormitorios > 0
                ? detailsProperties?.dormitorios > 1
                    ? detailsProperties?.dormitorios + " quartos "
                    : "1 quarto "
                : ""
            }${
                detailsProperties?.suites > 0
                ? detailsProperties?.suites > 1
                    ? "e " + detailsProperties?.suites + " suítes "
                    : "e 1 suíte "
                : ""
            }em ${detailsProperties?.cidade?.nome}`.replace(/\s*\n\s*/g, " ");

        const shareData = {
            title: `${detailsProperties?.tipo?.nome} ${"em "+detailsProperties?.cidade?.nome}`,
            text: text,
            url: window.location.href, // Você pode personalizar a URL
        };
    
        if (navigator.share) {
            try {
                await navigator.share(shareData);
                console.log("Compartilhado com sucesso!");
            } catch (err) {
                console.error("Erro ao compartilhar:", err);
            }
        } else {
            // Fallback para navegadores que não suportam a Web Share API
            alert("Compartilhamento não suportado neste navegador. URL copiada para a área de transferência!");
            navigator.clipboard.writeText(shareData.url);
        }
    };

    return (
        <ul className={styles.baloes_right}>
            <li><button className={styles.balao_redondo}><FaShareAlt onClick={handleShare} className={styles.icon_balao} style={{margin: 0,fontSize: 24,marginTop: 5}}/></button></li>
            { favorito.indexOf(detailsProperties?.id) >= 0 ?
                    <li className={styles.adjust_favorito} key={"favoritos"}>
                        <div
                            className={styles.favorito}
                        >
                            <button className={styles.balao_redondo}><FaHeart onClick={() => delete_favorito(detailsProperties?.id)} className={styles.icon_balao} style={{margin: 0,fontSize: 24,marginTop: 5,color: "red"}}/></button>
                        </div>
                    </li>
                :
                    <li className={styles.adjust_favorito} key={"incluir_favoritos"}>
                        <div
                            className={styles.favorito}
                        >
                            <button className={styles.balao_redondo}><FaRegHeart onClick={() => include_favorito(detailsProperties?.id)} className={styles.icon_balao} style={{margin: 0,fontSize: 24,marginTop: 5}}/></button>
                        </div>
                    </li>
                }
        </ul>
    );
};

export default Compartilhar;

export const getServerSideProps = async () => ({ notFound: true });
